// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__7o-OB","header":"ClearentDisclaimer_header__3KYPn","inner":"ClearentDisclaimer_inner__3W8fQ"};